export const randomString = () => Math.random().toString(16).slice(-4);

export default randomString;
